import { GlLoadingIcon } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { n__, s__ } from '~/locale';
import ReviewerDropdown from '../../../../../../../app/assets/javascripts/merge_requests/components/reviewers/reviewer_dropdown.vue?vue3';
export default {
    name: 'ReviewerTitleEE',
    components: {
        GlLoadingIcon,
        ReviewerDropdown
    },
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        numberOfReviewers: {
            type: Number,
            required: true
        },
        editable: {
            type: Boolean,
            required: true
        },
        reviewers: {
            type: Array,
            required: false,
            default: ()=>[]
        }
    },
    computed: {
        reviewerTitle () {
            const reviewers = this.numberOfReviewers;
            return n__('Reviewer', `%d Reviewers`, reviewers);
        }
    },
    i18n: {
        changeReviewer: s__('MergeRequest|Change reviewer')
    }
};
